const validateName = (name: string): boolean => {
  const trimmedName = name.trim();
  const regex = /^\D+/;

  return !(trimmedName.length === 0 || !regex.test(trimmedName) || trimmedName.length < 2 || trimmedName.length > 64);
};

export const validateFirstName = (firstName: string): boolean => {
  return validateName(firstName);
};

export const validateLastName = (lastName: string): boolean => {
  return validateName(lastName);
};

export const normalizeBirthdate = (birthdate: string): string => {
  const trimmedBirthdate = birthdate.trim();

  const isoMatch = trimmedBirthdate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${day}.${month}.${year}`;
  }

  return trimmedBirthdate;
};

export const validateBirthdate = (birthdate: string): boolean => {
  const normalizedBirthdate = normalizeBirthdate(birthdate);
  const match = normalizedBirthdate.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);

  if (!match) {
    return false;
  }

  const [, dayString, monthString, yearString] = match;
  const day = Number(dayString);
  const month = Number(monthString);
  const year = Number(yearString);

  const date = new Date(year, month - 1, day);

  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

export const validatePhoneNumber = (phoneNumber: string): boolean => {
  return /^[0-9+\s()/.-]{6,20}$/.test(phoneNumber.trim());
};
